<template>
  <div>
    <h1>This is an Account page</h1>
    <router-link :to="{name:'home'}">Home</router-link>
  </div>
</template>
